import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {hideModal, SELECT3, INFO, INFO_TYPE_ERROR} from '../../../modules/modals'
import {connect} from 'react-redux'
import ReactSelect from 'react-select'
import axios from 'axios';
import {ajaxUrls} from "../../../settings/routes";
import {getSortStringCB, sortCB} from "../../../helpers/common";
import RestService from '../../../helpers/RestService'

class Select3 extends Component {
    constructor(props) {
        super(props)
        const that = this
        const {initValue = {}, initValue2 = {}, initValue3 = {}} = props
        this.state = {
            before: null,
            before2: null,
            before3: null,
            value : null,
            value2: initValue2,
            value3: initValue3,
            options: props.options,
            options2: [],
            options3: []
        }
        /*axios.defaults.headers.common = {
            'Accept': 'application/json, text/plain',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
            'X-Requested-With' : 'XMLHttpRequest',
        };*/
    }
    render() {
        let {zIndex, title, selectTxt, okButtonTxt, cancelButtonTxt, options, clearable = true} = this.props


        let {formatMessage} = this.context
        if (!okButtonTxt) okButtonTxt = formatMessage('Copy')
        if (!cancelButtonTxt) cancelButtonTxt = formatMessage('Cancel')
        return (
            <Modal
                isOpen={true}
                style={{
                    overlay: {zIndex},
                }}
                onRequestClose={this.handleClose}
                overlayClassName="custom-modal"
                className="custom-modal-content create-dialog-modal-content"
            >
                <div className="create-dialog-modal-content__header">
                    <div className="create-dialog-modal-content__title">{title}</div>
                    <div
                        onClick={this.handleClose}
                        className="create-dialog-modal-content__close"
                    ></div>
                </div>
                <div className="create-dialog-modal-content__body">
                    <form className="create-dialog-form">
                        <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                            <label>{selectTxt}</label>
                            <ReactSelect
                                valueKey = "id"
                                labelKey = "name"
                                options = {this.state.options}
                                value = {this.state.before!==null?this.state.before:this.state.value}
                                onChange={this.onChooseSubject}
                                clearable = {clearable}
                            />
                        </div>
                        <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                            <label>{selectTxt}</label>
                            <ReactSelect
                                valueKey = "id"
                                labelKey = "name"
                                options = {this.state.options2}
                                value = {this.state.before2!==null?this.state.before2:this.state.value2}
                                onChange={this.onChooseCategory}
                                clearable = {clearable}
                            />
                        </div>
                        <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                            <label>{selectTxt}</label>
                            <ReactSelect
                                valueKey = "id"
                                labelKey = "name"
                                options = {this.state.options3}
                                value = {this.state.before3!==null?this.state.before3:this.state.value3}
                                onChange={this.onChooseSubCategory}
                                clearable = {clearable}
                            />
                        </div>

                        <div className="create-dialog-form__group flex">
                            <button
                                onClick={this.handleOkClick}
                                className="btn btn-primary mr-auto"
                                type="button"
                            >{okButtonTxt}</button>
                            <button
                                onClick={this.handleClose}
                                className="btn btn-warning"
                                type="button"
                            >{cancelButtonTxt}</button>
                        </div>
                    </form>
                </div>
            </Modal>
        )
    }

    handleOkClick = () => {
        const {okCb} = this.props
        okCb(this.state)
    }

    onChooseSubject = (value, that = this) => {
        that.setState({value:value})
        that.setState({options2: []})
       // that.setState({before: value})
        axios({
            method: 'post',
            url:ajaxUrls.categoriesList,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-Token': RestService.getCsrfToken(),
                'X-Requested-With' : 'XMLHttpRequest',
            },
            data: JSON.stringify({
                Branch: JSON.stringify({
                    branch_id : value.id,
                })
            })
        })
            .then(function (response) {
                if (response.data.categories.length < 1) {
                    hideModal({modalType: SELECT3})
                    showModal({
                        modalType: INFO,
                        modalProps: {
                            title: "Error",
                            text: "Subject has no categories, please create one before copying",
                            infoType: INFO_TYPE_ERROR,
                        }
                    })
                    return false;
                }
                that.setState({options2: response.data.categories.sort(sortCB)})
                //that.forceUpdate()
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    onChooseCategory = (value, that = this) => {
        that.setState({value2:value})
        that.setState({options3: []})
        //that.setState({before2: value})
        if(null === value.id){
            hideModal({modalType:SELECT3})
            return false
        }
        axios({
            method: 'post',
            url:ajaxUrls.subcategoriesList,
            headers: {
                'Accept': 'application/json, text/plain',
                'X-CSRF-Token': RestService.getCsrfToken(),
                'X-Requested-With' : 'XMLHttpRequest',
            },
            data: JSON.stringify({Category: JSON.stringify({
                category_id : value.id,
            })})
        })
            .then(function (response) {
                if(response.data.subcategories.length >0){
                    that.setState({options3:response.data.subcategories.sort(sortCB)})
                }})
            .catch(function (error) {
                console.log(error);
            });
    }
    onChooseSubCategory = (value, that = this) => {
        that.setState({value3:value})
        //that.setState({before: value})

    }

    handleClose = () => this.props.hideModal({modalType: SELECT3})
    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    null,
    {hideModal}
)(Select3)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/common/Select3.js